module.exports = __webpack_public_path__ + "static/media/functionalCoasterWallet-large.a2575ec4.jpg";